import React, { useState, useEffect } from 'react'
import { Select } from 'antd'

import { getMerchants } from '@services/merchantService'
import { merchantCategories } from '../../common/constants'
const { Option } = Select

const MerchantSelect = (props: any) => {
  const {
      value,
      onChange,
      mode,
      placeholder,
      showArrow = true,
      showSearch = true,
      allowClear = true,
      notFoundContent,
      optionFilterProp,
      showCategory = false
  } = props

  const [merchants, setMerchants] = useState([])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    getMerchants()
      .then(res => {
        setTimeout(() => {
          const merchants = res.data.merchants || []
          setMerchants(showCategory ? [...merchantCategories, ...merchants] : merchants)
          setLoading(false)
        }, 100)
      })
      .catch(e => {
        setLoading(false)
        setMerchants([])
      })
  }, [showCategory])

  return (
    <Select
      value={value}
      showSearch={showSearch}
      mode={mode}
      allowClear={allowClear}
      optionFilterProp={optionFilterProp || 'children'}
      placeholder={placeholder}
      defaultActiveFirstOption={false}
      showArrow={showArrow}
      onChange={onChange}
      notFoundContent={notFoundContent}
      loading={loading}
      style={{width: 200}}
    >
      {merchants.map(item => (
        <Option value={item['id']} key={item['id']}>
          {item['name']}
        </Option>
      ))}
    </Select>
  )
}

export default MerchantSelect
